import { render, staticRenderFns } from "./ProductAddons.vue?vue&type=template&id=1a32034b&scoped=true&"
import script from "./ProductAddons.vue?vue&type=script&lang=js&"
export * from "./ProductAddons.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddons.vue?vue&type=style&index=0&id=1a32034b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a32034b",
  null
  
)

export default component.exports